// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9066 ? "dc112a36" : chunkId) + "-" + {"7853":"41237714e301f83a","9066":"ee92aa0ad18635c3"}[chunkId] + ".js";
};